/* eslint-disable no-case-declarations */
import { ActionTypes } from '../actions/user'
import i18n from '../services/i18n'

const initialState = {
    session: {
        accessToken: null,
        email: null,
        env: process.env.NODE_ENV,
        error: null,
        expiresAt: null,
        idToken: null,
        isAuthenticated: false,
        isWorking: false,
        lastLoginAt: null,
        passwordLastUpdatedAt: null,
        sessionData: null,
        sessionId: 'NOT_LOGGED_IN-' + Date.now(),
    },
    profile: {
        isFetched: false,
        isWorking: false,
    },
    isLogingWithSession: false,
    authV2: {
        authState: null,
        challenge: null,
        verifier: null,
        authentication: 'none',
        redirectAfterLogin: null,
    },
}

function userReducer(state = initialState, { type, payload = {} }) {
    switch (type) {
        case 'persist/REHYDRATE': {
            const { user: lastState = {} } = payload

            return {
                ...state,
                session: {
                    ...state.session,
                    ...(lastState.session || {}),
                    error: initialState.session.error, // Remove previous error message
                    isWorking: false,
                },
                profile: {
                    ...state.profile,
                    ...(lastState.profile || {}),
                    isWorking: false,
                    isFetched: false,
                },
                authV2: {
                    ...(lastState?.authV2 || {}),
                },
            }
        }
        case ActionTypes.LOGIN_FAILURE: {
            const { response } = payload
            const { msg: error = '' } = response || {}
            return {
                ...state,
                session: {
                    ...state.session,
                    isAuthenticated: false,
                    isWorking: false,
                    error,
                },
            }
        }
        case ActionTypes.LOGIN_REQUEST:
            return {
                ...state,
                session: {
                    ...state.session,
                    error: null,
                    isWorking: true,
                },
            }
        case ActionTypes.LOGIN_SESSION_REQUEST:
            return {
                ...state,
                session: {
                    ...state.session,
                    error: null,
                    isWorking: true,
                },
                isLogingWithSession: true,
            }
        case ActionTypes.LOGIN_SUCCESS:
            return {
                ...state,
                session: {
                    ...state.session,
                    accessToken: payload.accessToken,
                    email: payload.email,
                    env: process.env.NODE_ENV,
                    error: null,
                    expiresAt: payload.expiresAt,
                    idToken: payload.idToken,
                    isAuthenticated: true,
                    isWorking: false,
                    sessionId: payload.sessionId,
                },
                authV2: {
                    ...state.authV2,
                    authentication: 'authenticated',
                },
            }
        case ActionTypes.LOGIN_SESSION_SUCCESS:
            return {
                ...state,
                session: {
                    ...state.session,
                    email: payload.data.user.email,
                    expiresAt: null,
                    lastLoginAt: payload.data.user.lastLoginAt,
                    passwordLastUpdatedAt: payload.data.user.passwordLastUpdatedAt,
                    sessionData: null,
                    sessionId: payload.id,
                    isAuthenticated: true,
                    isWorking: false,
                    error: null,
                    env: process.env.NODE_ENV,
                },
                isLogingWithSession: false,
            }
        case ActionTypes.LOGOUT_REQUEST:
            return {
                ...state,
                session: {
                    ...state.session,
                    error: null,
                    isWorking: true,
                },
            }
        case ActionTypes.LOGIN_V2_LOGOUT_SUCCESS:
        case ActionTypes.LOGOUT_SUCCESS:
            return {
                ...state,
                session: {
                    ...initialState.session,
                    email: state.session.email,
                },
                profile: {
                    ...initialState.profile,
                },
                authV2: {
                    ...initialState.authV2,
                },
            }
        case ActionTypes.EXPIRED_SESSION:
            return {
                ...state,
                session: {
                    ...initialState.session,
                    email: state.session.email,
                    error: i18n.t('user-session-expired'),
                },
                profile: {
                    ...initialState.profile,
                },
                authV2: {
                    ...initialState.authV2,
                },
            }
        case ActionTypes.USER_DATA_REQUEST:
            return {
                ...state,
                profile: {
                    ...state.profile,
                    isWorking: true,
                },
            }
        case ActionTypes.USER_DATA_SUCCESS:
            return {
                ...state,
                profile: {
                    ...state.profile,
                    ...payload,
                    isFetched: true,
                    isWorking: false,
                },
            }
        case ActionTypes.SAVE_SESSION:
            return {
                ...state,
                session: {
                    ...state.session,
                    accessToken: payload.sessionId,
                    sessionId: payload.sessionId,
                    idToken: payload.sessionId,
                    isAuthenticated: false,
                },
            }
        case ActionTypes.LOGIN_V2_STEP1:
            return {
                ...state,
                authV2: {
                    ...state.authV2,
                    authState: payload.authState,
                    challenge: payload.challenge,
                    verifier: payload.verifier,
                    authentication: 'started',
                },
                session: {
                    ...state.session,
                    isWorking: true,
                },
            }
        case ActionTypes.LOGIN_V2_STEP2_REQUEST:
            return {
                ...state,
                session: {
                    ...state.session,
                    isWorking: true,
                },
            }
        case ActionTypes.LOGIN_V2_STEP2_FAILURE:
            return {
                ...state,
                authV2: {
                    ...state.authV2,
                    authentication: 'failed',
                },
                session: {
                    ...state.session,
                    isWorking: false,
                },
            }
        case ActionTypes.SAVE_REDIRECT_AFTER_LOGIN_PATH:
            return {
                ...state,
                authV2: {
                    ...state.authV2,
                    redirectAfterLogin: payload.path,
                },
            }
        default:
            return state
    }
}

function getUsername(state) {
    return state?.user?.session?.email
}

function isUserAuthenticated(state = {}) {
    return state?.user?.session?.isAuthenticated || false
}

function getRedirectAfterLogin(state) {
    return state.user.authV2.redirectAfterLogin
}

export { getUsername, getRedirectAfterLogin, isUserAuthenticated }

export default userReducer
